import React, { useEffect, useState } from "react";
import work1 from "./../images/kenenisa.jpg";
import work2 from "./../images/work-2.jpg";
import work3 from "./../images/work-3.jpg";
import work4 from "./../images/work-4.jpg";
import work5 from "./../images/work-5.jpg";
import "./Project.css";
import { Link, useNavigate } from "react-router-dom";
import variants from "./../variant";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import Media from "./Media";
const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState("All");
  console.log(active)
 
  const loadProject = async () => {
    try {
      const res = await axios.get(
        "https://back.waratechnology.com/api/portifolio/getproject"
      );
      console.log(res.data.data)
      setProjects(res.data.data);
    } catch (err) {
      console.error("Error loading projects:", err);
    }
  };

const loadCategorizedProjects = async (category) => {
  console.log("Fetching projects for category:", {params:{category}});
  try {
    const res = await axios.get(
      "https://back.waratechnology.com/api/portifolio/getctproject",
      {
        params: { category }, // Pass category as query parameter
      }
    );
    setProjects(res.data.data);
  } catch (err) {
    console.error("Error loading filtered projects:", err);
  }
};


  useEffect(() => {
    if (active === "All") {
      loadProject();
    } else {
      loadCategorizedProjects(active);
    }
  }, [active]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ y: 10, opacity: 1 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 1 }}
        transition={{ duration: 0.2 }}
        id="work"
        className="container-fluid project py-120 font-mono project_area "
      >
        <div className="container py-8 ">
          <div
            className="text-center mx-auto max-w-[600px] mt-20  wow fadeIn"
            data-wow-delay=".3s"
          >
            <h5 className="text-gray-500">Our Project</h5>
            <h1 className="font-play font-bold text-3xl md:text-4xl lg:text-6xl">
              Recent Projects
            </h1>
          </div>
          <div className="flex justify-center items-center my-4">
            <ul className="flex font-play text-sm md:text-lg">
              <div
                className="px-2 md:px-3 lg:px-4 cursor-pointer"
                onClick={() => setActive("All")}
              >
                <li className="py-1">All</li>
                <hr
                  className={
                    active === "All"
                      ? "block border-[1px] border-black border-solid w-full"
                      : "hidden"
                  }
                />
              </div>
              <div
                className="px-2 md:px-3 lg:px-4 cursor-pointer"
                onClick={() => setActive("Website")}
              >
                <li className="py-1">Website</li>
                <hr
                  className={
                    active === "Website"
                      ? "block border-[1px] border-black border-solid w-full"
                      : "hidden"
                  }
                />
              </div>
              <div
                className="px-2 md:px-3 lg:px-4 cursor-pointer"
                onClick={() => setActive("Mobile App")}
              >
                <li className="py-1">Mobile App</li>
                <hr
                  className={
                    active === "Mobile App"
                      ? "block border-[1px] border-black border-solid w-full"
                      : "hidden"
                  }
                />
              </div>
              <div
                className="px-2 md:px-3 lg:px-4 cursor-pointer"
                onClick={() => setActive("Graphics Design")}
              >
                <li className="py-1">Graphics</li>
                <hr
                  className={
                    active === "Graphics Design"
                      ? "block border-[1px] border-black border-solid w-full"
                      : "hidden"
                  }
                />
              </div>
              <div
                className="px-2 md:px-3 lg:px-4 cursor-pointer"
                onClick={() => setActive("Digital Marketing")}
              >
                <li className="py-1">Marketing</li>
                <hr
                  className={
                    active === "Digital Marketing"
                      ? "block border-[1px] border-black border-solid w-full"
                      : "hidden"
                  }
                />
              </div>
            </ul>
          </div>
          <div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-8 gap-1 wow fadeIn"
            data-wow-delay=".5s"
          >
            {projects.map((data, index) => (
              <div className="project-item h-full md:h-60 w-full">
                <div className="project-img h-full w-full flex items-center relative">
                  <img
                    src={`https://back.waratechnology.com${data.image}`}
                    className="img-fluid h-fit   w-fit rounded-3xl"
                    alt=""
                  />
                  <div className="project-content absolute inset-0 flex items-center justify-center rounded-3xl">
                    <Link to={""} className="text-center">
                      <h4 className="text-secondary">{data.project_type}</h4>
                      <p className="m-0 text-white">{data.name}</p>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* <Media /> */}
      </motion.div>
    </AnimatePresence>
  );
};

export default Projects;
